import { ChangeEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SerializedError } from '@reduxjs/toolkit';
import { StyledTextField } from './styled';

type PropsTypes = {
  disabled: boolean;
  error: SerializedError | null;
  onChange: (channelName: string) => void;
};

export const ChannelURL = ({ disabled, error, onChange }: PropsTypes) => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      onChange(value);
    },
    [onChange]
  );

  return (
    <StyledTextField
      id="youtube-channel"
      onChange={handleChange}
      fullWidth
      size="small"
      disabled={disabled}
      label={t('account:youtubeChannel:whitelistContainer:label')}
      placeholder={t('account:youtubeChannel:whitelistContainer:placeholder')}
      variant="outlined"
      inputProps={{
        'data-testid': 'youtube-channel',
      }}
      InputLabelProps={{ shrink: true }}
      error={!!error}
    />
  );
};

export default ChannelURL;
